import { render, staticRenderFns } from "./cityCascader.vue?vue&type=template&id=bafe9942&scoped=true&"
import script from "./cityCascader.vue?vue&type=script&lang=js&"
export * from "./cityCascader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bafe9942",
  null
  
)

export default component.exports